import { useEffect } from 'react';
import { useLocation } from 'react-router';

// Use this if you want to use hash links to scroll directly to an anchor tag
export const useScrollToAnchor = (options: boolean | ScrollIntoViewOptions = true) => {
  const { hash, key } = useLocation();
  useEffect(() => {
    if (hash) {
      const targetElement = document.getElementById(hash.substring(1));
      targetElement?.scrollIntoView(options);
    }
  }, [key, hash, options]);
};
